import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/locations/create")({
  component: () => (
    <MaskRedirect
      to="/admin/locations"
      action="create"
      mask="/admin/locations/create"
    />
  ),
});
